import React from "react";
import styled from "styled-components";
import anniversaryBackground from "../../assets/video/anniversary-background.mp4";
import logoImage from "../../assets/images/logos/40th-color.png";

const IntroSectionWrapper = styled.section`
  position: relative;
  color: #fff;
  text-align: center;
  padding: 60px 20px;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  overflow: hidden;

  video {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    object-fit: cover;
    z-index: -2;
  }

  &:before {
    content: "";
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background: rgba(0, 0, 0, 0.6);
    z-index: -1;
  }

  h1 {
    font-size: 2.5rem;
    margin-bottom: 10px;
    z-index: 1;
  }

  p {
    font-size: 1.2rem;
    max-width: 600px;
    line-height: 1.5;
    z-index: 1;
  }
`;

const Logo = styled.img`
  max-width: 150px;
  margin-bottom: 15px;
  z-index: 1;
  filter: drop-shadow(0px 4px 6px rgba(0, 0, 0, 0.2));
`;

const IntroSection = () => (
  <IntroSectionWrapper>
    <video autoPlay loop muted playsInline>
      <source src={anniversaryBackground} type="video/mp4" />
    </video>
    <Logo src={logoImage} alt="40th Anniversary Logo" />
    <h1>Celebrating 40 Years of Habitat Buffalo</h1>
    <p>
      Discover the events, stories, and milestones that mark this special year.
    </p>
  </IntroSectionWrapper>
);

export default IntroSection;
